import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import ConditionsMarquee from "./components/ConditionsMarquee";
import Approach from "./components/Approach";
import Services from "./components/Services";
import Transformations from "./components/Transformations";
import Team from "./components/Team";
import ConsultForm from "./components/ConsultForm";
import Footer from "./components/Footer";

const Landing = () => (
  <main data-testid="landing-page" className="bg-[#F7F4EB] text-[#1E3A2B] overflow-x-hidden">
    <Navbar />
    <Hero />
    <ConditionsMarquee />
    <Approach />
    <Services />
    <Transformations />
    <Team />
    <ConsultForm />
    <Footer />
  </main>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#1E3A2B",
            color: "#FCFBF7",
            border: "1px solid #C25E3E",
            fontFamily: "Outfit, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
